var Flickity = require('flickity');

jQuery(function($) {

    var brand_list = $('.brand-list .item-wrapper');
    if (brand_list.length) {
        var flkty = new Flickity( brand_list[0], {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            groupCells: true,
            wrapAround: true,
        });
    }

    var testimonials = $('.testimonials ul');
    if (testimonials.length) {
        var flkty = new Flickity( testimonials[0], {
            // options
            groupCells: true,
            contain: true,
            pageDots: false,
            freeScroll: true
        });
    }

});